interface ImageProps {
  src: string,
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
}

const Image: React.FC<ImageProps> = ({ src, alt, width, height, className}) => {
  return <img className={className} src={src} alt={alt} width={width} height={height} />;
};


export default Image;